/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import {useCallback, useEffect, useState} from "react";
import TextField from "@mui/material/TextField";
import {Button} from "@mui/material";
import {useNavigate} from "react-router-dom";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

import {Login} from "../Login";
import {useApiCallback} from "../util/Api";
import {useToastStore} from "../Toast";
import TotpInput from "../part/TotpInput";
import {PWLOGIN} from "../../useAppConfigStore";


export default function LoginForm() {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [totp, setTotp] = useState('')
    const [loading, setLoading] = useState(false)
    const [checked, setChecked] = useState(false)
    const [mfaRequired, setMfaRequired] = useState(false)
    const showError = useToastStore(state => state.showError);
    const showSuccess = useToastStore(state => state.showSuccess);
    const showInfo = useToastStore(state => state.showInfo);
    const [newPassword, setNewPassword] = useState('')

    const navigate = useNavigate()

    const checkLogin = useApiCallback('GET', '/api/login', {
        setLoading,
        onDone: setChecked,
    })
    useEffect(checkLogin, [checkLogin])

    const handleLoginResponse = useCallback(resp => {
        console.log('RESPO', resp)
        if (resp.status === 'ok') {
            showSuccess('Authentication successful')
            setNewPassword('')
            setPassword('')
            setUsername('')
            navigate(0)
        } else if (resp.data === 'mfa required') {
            setMfaRequired(true)
            setNewPassword('')
            showInfo('Multi-factor auth code is required')
        } else if (resp.data.startsWith('password reset:')) {
            setNewPassword(resp.data.replace('password reset: ', ''))
        } else {
            showError(`${resp.status}: ${resp.data}`)
            setNewPassword('')
        }
    }, [navigate, showError, showInfo, showSuccess, setNewPassword])

    const doLogin = useApiCallback('POST', `/api/login`, {
        data: {username, password, totp},
        setLoading,
        onDone: handleLoginResponse,
        returnAll: true,
        ignoreErrors: true,
    })

    if (checked === false || checked?.data?.active) {
        // if user logged in state hasnt been checked yet, or if the user is logged in, dont show the login form
        return ''
    }

    if (mfaRequired) {
        window.addEventListener('message', (event) => {
            if (event.data.action === 'totpResponse') {
                setTotp(event.data.totpCode)
            }
        });

        window.postMessage({
            action: 'requestTOTP',
            accountName: 'DEA DataHub'
        }, '*');
    }

    if (!PWLOGIN) {
        return <Container>
            <form onSubmit={() => false}>
                Please Login
                <br/>
                <br/>
                <Login/>
            </form>
        </Container>
    }

    return <Container><form onSubmit={() => false}>
        <Stack direction="column" spacing={2} sx={{
                  justifyContent: "center",
                  alignItems: "center",
              }}
        >
            <Box p={4}>Please Login</Box>
            <Login/>
            <Typography p={3}>
                <i>- or -</i>
            </Typography>
            <TextField
                label="Username/Email"
                disabled={loading}
                InputLabelProps={{shrink: true}}
                value={username}
                inputProps={{autoComplete:"email", type:"email"}}
                onChange={(event) => {
                    setUsername(event.target.value.toLowerCase())
                }}
                m={2}
                mt={4}
                sx={{width: '300px'}}
            />
            <TextField
                label="Password"
                disabled={loading}
                InputLabelProps={{shrink: true}}
                value={password}
                type="password"
                inputProps={{autoComplete:"current-password"}}
                onChange={(event) => {
                    setPassword(event.target.value)
                }}
                sx={{width: '300px', margin: 2}}
            />
            {mfaRequired
                ? (
                    <TotpInput
                        label="Multi Factor Authentication"
                        disabled={loading}
                        value={totp}
                        setValue={setTotp}
                    />
                )
                : ''
            }
            {newPassword
                ? (
                    <Stack my={4}>
                        <Typography>
                            Your new password is below.
                        </Typography>
                        <code style={{display:'inline-block', border: '1px solid red', borderRadius:10}}>{newPassword}</code>
                        <Typography>
                            Please record this password somewhere safe,
                            then copy and paste it into the password box above to login.
                        </Typography>
                    </Stack>
                )
                : ''
            }

            <Button
                disabled={loading}
                type="submit"
                onClick={() => doLogin()}
            >Login</Button>
        </Stack>
    </form></Container>
}
